import { useState, useEffect } from 'react';
import { collection, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase';

/**
 * Real-time travel credits for a client.
 *
 * Read access is open to the client (they can see what credit they hold), but only STX can issue,
 * apply or reverse one — see firestore.rules and src/utils/travelCredits.js.
 */
export function useTravelCredits(clientId) {
  const [credits, setCredits] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!clientId) { setCredits([]); setLoading(false); return; }
    setLoading(true);
    const unsub = onSnapshot(
      collection(db, 'clients', clientId, 'travelCredits'),
      snap => {
        setCredits(snap.docs.map(d => ({ id: d.id, ...d.data() })));
        setLoading(false);
      },
      () => { setCredits([]); setLoading(false); },
    );
    return unsub;
  }, [clientId]);

  return { credits, loading };
}
